module.exports = __webpack_public_path__ + "img/customer_service.1c643d58.svg";